// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { z } from "zod";

// Validation for the Create Store dialog. Extracted from the dialog so it can be unit-tested
// directly (and reused) without pulling in the component.
export const createStoreSchema = z.object({
  storeName: z
    .string()
    .min(3, "Must be 3-64 characters")
    .max(64, "Must be 3-64 characters")
    .regex(/^[a-z0-9_]+$/, "Only lowercase, numbers, and underscores"),
  chainName: z.string().min(1, "Required"),
  storeCode: z.string().min(1, "Required"),
  legibleName: z.string().trim().min(1, "Required").max(100),
  timeZone: z.string().min(1, "Required"),
  // null is the empty value so clearing the picker leaves nothing to send
  installDate: z.string().nullish(),
});

export type CreateStoreValues = z.infer<typeof createStoreSchema>;
